import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Events from '@/hooks/events';
import actions from '../constants';

const useUpdateRequestFieldsProperties = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ properties, fields, entity }) => handler({
    type: actions.UPDATE_REQUEST_FIELDS_PROPERTIES,
    category,
    code,
    properties,
    fields,
    entity,
  }), [category, code]);
};

const useShowApproveRequest = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ action }) => handler({
    type: actions.SHOW_APPROVE_REQUEST, category, code, action,
  }), [category, code]);
};

const useUpdateRequestPanels = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ index, panel }) => handler({
    type: actions.UPDATE_REQUEST_PANELS, category, code, index, panel,
  }), [category, code]);
};

const useUpdateActiveStep = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ step }) => handler({
    type: actions.UPDATE_STEP, category, code, step,
  }), [category, code]);
};

const useUpdateRequestProperties = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ properties }) => handler({
    type: actions.UPDATE_REQUEST_PROPERTIES, category, code, properties,
  }), [category, code]);
};

const useDestroyRequests = () => {
  const handler = useDispatch();
  return useCallback(({ items, isArchival, silent }) => handler({
    type: actions.DESTROY_REQUESTS, items, isArchival, silent,
  }), []);
};

const useUpdateRequestFields = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ entity, properties }) => handler({
    type: actions.UPDATE_REQUEST_FIELDS, category, code, entity, properties,
  }), [category, code]);
};

const useUpdateRequestTransferType = (category, { code }) => {
  const handler = useDispatch();
  return useCallback(({ transferType }) => handler({
    type: actions.UPDATE_REQUEST_TRANSFER_TYPE, category, code, transferType,
  }), [category, code]);
};

const useToggleRequestsSelected = (category) => {
  const handler = useDispatch();
  return useCallback(({ selected }) => handler({
    type: actions.TOGGLE_REQUESTS_SELECTED, category, selected,
  }), [category]);
};

const useToggleRequestColumnOrderBy = (category) => {
  const handler = useDispatch();
  return useCallback(({ orderByColumn }) => handler({
    type: actions.TOGGLE_REQUEST_COLUMN_ORDER_BY, category, orderByColumn,
  }), [category]);
};

const useToggleRequestSingleSorting = (category) => {
  const handler = useDispatch();
  return useCallback(() => handler({
    type: actions.TOGGLE_REQUEST_SINGLE_SORTING, category,
  }), [category]);
};

const useToggleRequestsPresentation = (category) => {
  const handler = useDispatch();
  return useCallback(({ display }) => handler({
    type: actions.TOGGLE_REQUESTS_PRESENTATION, category, display,
  }), [category]);
};

const useUpdateRequestsFilter = (category) => {
  const handler = useDispatch();
  return useCallback(({ value }) => handler({
    type: actions.UPDATE_REQUESTS_FILTER, category, value,
  }), [category]);
};

const useUpdateRequestsFlags = (category) => {
  const handler = useDispatch();
  return useCallback(({
    pendingFlag, approvedFlag, deniedFlag, errorFlag,
  }) => handler({
    type: actions.UPDATE_REQUESTS_FLAGS, category, pendingFlag, approvedFlag, deniedFlag, errorFlag,
  }), [category]);
};

export default {
  useAddSourcesToRequest: (category, { code }) => Events.useDispatchByCode(
    actions.ADD_SOURCES_TO_REQUEST,
    category,
    code,
  ),
  useCreateRequest: (category, { code }) => Events.useDispatchByCode(actions.CREATE_REQUEST, category, code),
  useDestroyRequests,
  useFetchRequests: (category) => Events.useFetchByCategory(actions.FETCH_REQUESTS, category),
  useRefreshRequests: (category) => Events.useRefreshByCategory(actions.REFRESH_REQUESTS, category),
  useRemoveRequestSteps: (category, { code }) => Events.useDispatchByCode(
    actions.REMOVE_REQUEST_STEPS,
    category,
    code,
  ),
  useShowApproveRequest,
  useShowArchiveRequest: (category, { code }) => Events.useDispatchByCode(actions.SHOW_ARCHIVE_REQUEST, category, code),
  useShowArchiveRequests: (category) => Events.useDispatchByCategory(actions.SHOW_ARCHIVE_REQUESTS, category),
  useShowDeleteRequest: (category, { code }) => Events.useDispatchByCode(actions.SHOW_DELETE_REQUEST, category, code),
  useShowDeleteRequests: (category) => Events.useDispatchByCategory(actions.SHOW_DELETE_REQUESTS, category),
  useUpdateActiveStep,
  useUpdateRequestFields,
  useUpdateRequestFieldsProperties,
  useUpdateRequestPanels,
  useUpdateRequestProperties,
  useUpdateRequestTransferType,
  useUpdateRequestsFilter,
  useUpdateRequestsFlags,
  useToggleRequestsSelected,
  useToggleRequestColumnOrderBy,
  useToggleRequestSingleSorting,
  useToggleRequestsPresentation,
};
